import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const SparkleIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.47086 10.1925L9.30761 7.68222C9.48364 7.1541 10.2307 7.1541 10.4067 7.68222L11.2434 10.1925C11.647 11.4032 12.5972 12.3534 13.8079 12.757L16.3182 13.5937C16.8464 13.7698 16.8464 14.5168 16.3182 14.6928L13.8079 15.5296C12.5972 15.9332 11.647 16.8833 11.2434 18.0941L10.4067 20.6043C10.2307 21.1325 9.48364 21.1325 9.30761 20.6043L8.47086 18.0941C8.06726 16.8833 7.11715 15.9332 5.90635 15.5296L3.39609 14.6928C2.86797 14.5168 2.86797 13.7698 3.39609 13.5937L5.90635 12.757C7.11715 12.3534 8.06726 11.4032 8.47086 10.1925Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M17.1209 4.3677L17.5146 3.1864C17.5975 2.93787 17.9491 2.93787 18.0319 3.1864L18.4257 4.3677C18.6156 4.93749 19.0627 5.3846 19.6325 5.57452L20.8138 5.96829C21.0623 6.05114 21.0623 6.40266 20.8138 6.4855L19.6325 6.87927C19.0627 7.0692 18.6156 7.51631 18.4257 8.0861L18.0319 9.2674C17.9491 9.51591 17.5975 9.51591 17.5146 9.2674L17.1209 8.0861C16.931 7.51631 16.4839 7.0692 15.9141 6.87927L14.7327 6.4855C14.4843 6.40266 14.4843 6.05114 14.7327 5.96829L15.9141 5.57452C16.4839 5.3846 16.931 4.93749 17.1209 4.3677Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default SparkleIcon;